import React, { useEffect } from "react";
import { useState } from "react";
import {
  useDeleteAttendanceSchedule,
  useGetAttendanceSchedules,
} from "../../../redux/human-resources/hook/attendance";
import { PAGINATION_DEFAULT } from "../../../utils/constants";
import Button from "../../button";
import DataTable from "../../datatable";
import AddAttendanceSchedule from "../../modal/hr-section/attendance/add-attendance-schedule";
import SelectScheduleOption from "../../modal/hr-section/attendance/schedule-select-option";
import moment from "moment";
import { useGetEmployees } from "../../../redux/employees/hook";

const AttendanceScheduleTab = () => {
  useEffect(() => {}, []);

  const { data: employees } = useGetEmployees(9, 1, -1, "");
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: "",
    start_date: moment().format("YYYY-MM-DD"),
    end_date: moment().add(3, "month").format("YYYY-MM-DD"),
  });

  const { data: attendance_schedules } = useGetAttendanceSchedules(
    pagination?.limit,
    pagination?.page,
    pagination?.search,
    pagination?.start_date,
    pagination?.end_date
  );

  const { mutateAsync: deleteSchedule } = useDeleteAttendanceSchedule();

  const [showAddAttendanceSchedule, setShowAddAttendanceSchedule] =
    useState(false);
  const [scheduleData, setScheduleData] = useState();
  const [title, setTitle] = useState("Edit Attendance Schedule");
  const [buttonText, setButtonText] = useState("UPDATE");

  const [showAttendanceOptions, setShowAttendanceOptions] = useState(false);

  const tableConfig = {
    headers: [
      "Schedule Date",
      "Schedule Name",
      "Source",
      "Working Day",
      "Clock In",
      "Clock Out",
    ],
    keys: [
      "schedule_date",
      "schedule_name",
      "source",
      "working_day",
      "clockin_time",
      "clockout_time",
    ],
    mobileHeader: {
      left: {
        title: "Schedule Date",
        key: "schedule_date",
      },
      right: {
        title: "Schedule Name",
        key: "schedule_name",
      },
    },
  };

  const actionConfig = [
    {
      name: "View/Edit",
      color: "green",
      action: (id) => {
        let index = attendance_schedules.data.findIndex(
          (item) => item.id === id
        );
        setScheduleData(attendance_schedules.data[index]);
        setTitle("Edit Attendance Schedule");
        setShowAddAttendanceSchedule(true);
      },
    },
    {
      name: "Remove",
      color: "red",
      action: (id) => {
        let index = attendance_schedules.data.findIndex(
          (item) => item.id === id
        );
        deleteSchedule(attendance_schedules.data[index].id);
      },
    },
  ];

  return (
    <div className="flex flex-col bg-white rounded">
      {showAddAttendanceSchedule ? (
        <AddAttendanceSchedule
          isOpen={showAddAttendanceSchedule}
          scheduleData={scheduleData}
          buttonText={buttonText}
          title={title}
          closeModal={() => setShowAddAttendanceSchedule(false)}
        />
      ) : null}
      {showAttendanceOptions ? (
        <SelectScheduleOption
          isOpen={showAttendanceOptions}
          closeModal={() => setShowAttendanceOptions(false)}
        />
      ) : null}
      <div className="flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3">
        <div className="md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full">
          Attendance Schedules
        </div>
        <div className="flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full">
          <div className="md:w-fit w-[100%]">
            <Button
              text="New Attendance Schedule"
              type="submit"
              className="flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center"
              textClass={"!text-[11px]"}
              leftIcon={"add"}
              disabled={!employees}
              onClick={() => setShowAttendanceOptions(true)}
            />
          </div>
        </div>
      </div>
      <hr className="divider mt-2 mb-1" />
      <DataTable
        data={attendance_schedules}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        attendance={true}
        searchData={true}
        filterByDate={true}
      />
    </div>
  );
};

export default AttendanceScheduleTab;
